<div id=loader-bar class="loader-bar inactive">
   <div class="progress"></div>
</div>